import gql from "graphql-tag";
import { Test } from "../baseTypes";
export default gql`
  mutation UpdateTestPersonData($input: UpdateTestPatientDataInput!) {
    updateTestPatientData(input: $input) {
      companyId
      createdAt
      date
      userId
      identifier
      locationId
      location {
        name
        id
        locationId
      }
      testId
      result
      patient {
        firstname
        lastname
        insuranceNumber
      }
      company {
        id
        name
      }
    }
  }
`;
export interface UpdateTestPersonDataMutation {
  updateTestPatientData: Test | null;
}
